<template>
    <transition name="modal-fade">
        <div class="modal-component-backdrop">
            <div class="modal-component rounded-8" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modal-component-header bg-utel-v2-secondary text-primary" id="modalTitle">
                    <slot name="header">
                        <strong>Eliminar curso</strong>
                    </slot>
                    <button type="button" class="btn btn-close" @click="close" aria-label="Close modal">
                    </button>
                </header>

                <section class="modal-component-body px-4" id="modalDescription">
                    <slot name="body">
                        ¿Desea eliminar el curso {{ course.wordpress_course_title }}?
                    </slot>
                </section>

                <footer class="modal-component-footer justify-content-center d-flex">
                    <slot name="footer">
                    </slot>
                    <button type="button" class="btn text-primary bg-utel-v2-secondary mx-3" @click="close" aria-label="Close modal">
                        Cancelar
                    </button>
                    <button :disabled="deleting" type="button" class="btn text-white bg-utel" @click="deleteCourse" aria-label="Eliminar usuario">
                        {{ deleting ? 'Eliminando...' : 'Eliminar curso' }}
                    </button>
                </footer>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        props: ['course', 'url'],
        data(){
            return {
                urlDeleteCourse: `${this.url}/${this.course.id}`,
                deleting: false
            }
        },
        methods: {
            close(){
                this.$emit('close');
            },
            deleteCourse(){
                this.deleting = true;
                let context = this;
                axios.delete(context.urlDeleteCourse)
                .then((res) => {
                    context.$emit('reloadtable', true);
                    context.close();
                    this.deleting = false;
                })
                .catch(err => {
                    this.deleting = false;
                    console.log( err );
                })
            }
        }
    }
</script>
<style>
.modal-component-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-component {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
}

.modal-component-header,
.modal-component-footer {
    padding: 15px;
    display: flex;
}

.modal-component-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
}

.modal-component-footer {
    border-top: 1px solid #eeeeee;
    /*flex-direction: column;*/
    justify-content: flex-end;
    background: none !important;
}

.modal-component-body {
    position: relative;
    padding: 20px 10px;
}
/*
.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
}
*/
.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>
